import React, {useState} from 'react';
import Dropzone from 'react-dropzone';
import {connect} from 'react-redux';
import {Actions} from '../../../common/actions';
import XLSX from 'xlsx';
import ConfirmationModal from './ConfirmationModal';

const DragAndDropFile = (props) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [sheetsList, setSheetsList] = useState([]);
  const [acceptedFile, setAcceptedFile] = useState({});

  const handleDropFile = (acceptedFile) => {
    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, {'type': 'binary'});
      setSheetsList(wb.SheetNames || []);
      setAcceptedFile(acceptedFile);
      setShowConfirmation(true);
    };
    reader.readAsBinaryString(acceptedFile[0]);
  };

  return (
    <>
      <ConfirmationModal
        showConfirmation={showConfirmation}
        setShowConfirmation={setShowConfirmation}
        options={sheetsList}
        acceptedFile={acceptedFile}
      />
      <div className='dropZone-container'>
        <Dropzone
          onDrop={(acceptedFile) => handleDropFile(acceptedFile)}
          styles={{'dropzone': {'minHeight': 200, 'maxHeight': 250}}}>
          {({getRootProps, getInputProps}) => (
            <section className='dropZone-container'>
              <i className='material-icons upload-icon'>
                {'insert_drive_file'}
              </i>
              <div {...getRootProps()}>
                <input {...getInputProps()} />
                <p>
                  Arrastre aquí el archivo o súbalo haciendo click sobre este
                  texto.
                </p>
              </div>
            </section>
          )}
        </Dropzone>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    'ordersRawData': state.manageOrders.ordersRawData,
  };
};

const {fetchValidateXLXSOrderFile, uploadRawOrderFile} = Actions;

export default connect(mapStateToProps, {
  fetchValidateXLXSOrderFile,
  uploadRawOrderFile,
})(DragAndDropFile);
